/* Chez Josh — theme.js : bootstrap global (vanilla ESM). Expose window.ChezJosh : cart API, events, reveal. */

/* Active les apparitions au scroll uniquement hors éditeur (évite toute page blanche). */
if (!(window.Shopify && window.Shopify.designMode)) { document.documentElement.classList.add('cj-reveal'); }

const ChezJosh = window.ChezJosh || {};
ChezJosh.settings = ChezJosh.settings || {};
ChezJosh.routes = ChezJosh.routes || {};

ChezJosh.formatMoney = function (cents) {
  const amount = (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${amount} €`;
};

ChezJosh.events = (function () {
  const target = new EventTarget();
  return {
    on: (name, fn) => target.addEventListener(name, fn),
    off: (name, fn) => target.removeEventListener(name, fn),
    emit: (name, detail) => target.dispatchEvent(new CustomEvent(name, { detail })),
  };
})();

ChezJosh.cart = {
  async get() {
    const res = await fetch(`${ChezJosh.routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  },
  async add(items) {
    const res = await fetch(`${ChezJosh.routes.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Ajout au panier impossible.');
    }
    return res.json();
  },
  async change(payload) {
    const res = await fetch(`${ChezJosh.routes.cart_change_url || '/cart/change'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    return res.json();
  },
};

ChezJosh.addToCart = async function (items, { openDrawer = true } = {}) {
  ChezJosh.events.emit('cart:loading', { state: true });
  try {
    await ChezJosh.cart.add(items);
    const cart = await ChezJosh.cart.get();
    ChezJosh.events.emit('cart:updated', { cart, openDrawer });
    return cart;
  } catch (error) {
    ChezJosh.events.emit('cart:error', { error });
    throw error;
  } finally {
    ChezJosh.events.emit('cart:loading', { state: false });
  }
};

ChezJosh.qs = (sel, ctx = document) => ctx.querySelector(sel);
ChezJosh.qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

const REVEAL_SELECTOR = [
  '.hero__content', '.hero__media-wrap',
  '.value-props__head', '.value-prop',
  '.routine__head', '.routine__card', '.routine__summary',
  '.image-text__media', '.image-text__content',
  '.rich-text__inner',
].join(', ');

ChezJosh.initReveal = function () {
  const els = ChezJosh.qsa(REVEAL_SELECTOR).filter((el) => !el.dataset.revealBound);
  if (!els.length) return;
  els.forEach((el) => { el.dataset.revealBound = '1'; });
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = window.Shopify && window.Shopify.designMode;
  if (reduce || designMode || !('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  els.forEach((el) => io.observe(el));
};

if (document.readyState !== 'loading') ChezJosh.initReveal();
else document.addEventListener('DOMContentLoaded', () => ChezJosh.initReveal());
document.addEventListener('shopify:section:load', () => ChezJosh.initReveal());

window.ChezJosh = ChezJosh;
